
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { WTPEquipmentNameDDLAPI } from '../../Redux/DDLSlice'

export const WTPEquipmentNameDDL = (props) => {
    const { EquipmentName, setEquipmentName,WtpEquipmentType, IsPost,IsDisabled,Flag,rowData} = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WTP_EquipmentTypeID: WtpEquipmentType.ID,
            M_UserID: UserID,
            token: token,
        }
      
        dispatch(WTPEquipmentNameDDLAPI({ data }))
       
    }, [IsPost,WtpEquipmentType.ID])

    const { WTPEquipmentNameData } = useSelector(state => state.WTPEquipmentNameDDL)

    useEffect(() => {
        handleWTPEquipmentNameDDL()
    }, [WTPEquipmentNameData])

    const handleWTPEquipmentNameDDL = () => {
        
        if (WTPEquipmentNameData && WTPEquipmentNameData.table && WTPEquipmentNameData.table.length > 0) {
            let list = WTPEquipmentNameData.table.map((item, index) => ({
                value: item.m_wtP_EquipmentMasterID,
                label: item.equipmentDetails,
            }))

            setEquipmentName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
                Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            })
            
        }
        else {
            setEquipmentName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Equipment Name</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isDisabled={IsDisabled}
                isSearchable
                maxMenuHeight={150}
                value={{ value: EquipmentName.ID, label: EquipmentName.Label }}
                onChange={(e) => {
                    e ?
                        setEquipmentName({ ...EquipmentName, ID: e.value, Label: e.label })
                        :
                        setEquipmentName({ ...EquipmentName, ID: 0, Label: "Select..." })

                }}
                options={EquipmentName.DDL}
            />
        </div>
    )
}